import { selectAccount } from "~/domains/user/api/SetAccount";
import { invalidateNavigationCache } from "~/features/navigation/redux/navigationThunks";
import { redirectToPdp, toBeRedirectedToPdp } from "~/utils/redirectionUtil";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { removeQuoteSearchUrlState } from "~/domains/orders/quoteSearchUrlState";
import { consumeAccountSelectionReturnUrl } from "~/utils/accountSelectionContinuation";

export const setAccount = (accountId: string, salesOrg?: string) =>
  selectAccount({ accountId, salesOrg: salesOrg ?? "" }).then(() => {
    window.sessionStorage.setItem("accountChanged", "true");
    invalidateNavigationCache();
    const returnUrl = consumeAccountSelectionReturnUrl();
    if (returnUrl) {
      redirectToUrl(removeQuoteSearchUrlState(returnUrl));
    } else if (toBeRedirectedToPdp()) {
      redirectToPdp();
    } else {
      redirectToUrl("/");
    }
  });
